import { useI18n } from "vue-i18n";

export const useGetBleErrorMessage = () => {
  const { t } = useI18n();

  return (error: any) => {
    switch (error.message) {
      case "Not Accepted":
        return t("BleAuthNotAcceptedErrorText");
      case "Not synched":
        return t("BleAuthNotSynchedErrorText");
      case "Full":
        return t("BleAuthFullErrorText");
      case "NOT AUTHORIZED":
        return t("BleAuthNotAuthorizedErrorText");
      default:
        return error;
    }
  };
};
